// Step 7: Display a confirmation page in ConfirmationPage.js
import React from 'react';

function ConfirmationPage() {
  return <h1>Thank you for subscribing!</h1>;
}

//return as a react component

export default ConfirmationPage;